import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";

import type { NotificationRegistryConfig } from "components/NotificationsCenter/components";

type ExportNotificationProps = {
  icon: string;
  title: string;
  description?: string;
  closeToast: () => void;
};

export const ExportNotification = ({ icon, title, description, closeToast }: ExportNotificationProps) => (
  <NotificationContainer icon={icon} title={title} description={description} onCloseNotification={closeToast} />
);

export const ExportNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { style: { width: "340px", right: "30px" } },
  render: ({ closeToast, icon, title, description }) => <ExportNotification icon={icon} title={title} description={description} closeToast={closeToast} />
};
